import VisualSearchResultState, { initialState } from './State';
import {
  TOGGLE_VISUALSEARCH_GRAYSCALE,
  VISUALSEARCH_SET_IMAGE,
  VISUALSEARCH_SET_LUMINANCE,
  VisualSearchResultAction
} from './Actions';

function visualSearchResultReducer(state = initialState, action: VisualSearchResultAction): VisualSearchResultState {
  switch (action.type) {
    case TOGGLE_VISUALSEARCH_GRAYSCALE:
      return {
        ...state,
        enableGrayScale: action.enableGrayScale
      };
    case VISUALSEARCH_SET_IMAGE:
      return {
        ...state,
        imageLoaded: action.imageLoaded,
        imageSrc: action.imageSrc,
        imageData: action.imageData
      };
    case VISUALSEARCH_SET_LUMINANCE:
      return {
        ...state,
        luminanceSearch: action.luminanceSearch
      };
    default:
      return state;
  }
}

export default visualSearchResultReducer;
